import { Content, Row, Col, H1, Card, CardImgWrapper, CardContent, CardTitle, CardSubtitle } from 'components/common'
import { React, styled, mq } from 'x'
import { compose, lifecycle, withState } from 'recompose'



const Container = styled.div`
  padding: 30px 0 0 0;
`

const Title = styled(H1)`
  max-width: 100%;
  color: #3e4d72;
  text-align:center;
  width: 100%;
  margin-bottom: 30px;
  font-size:42px;
  line-height:1.2;
  font-weight:800;
`

const CardsContainer = styled.div`
  ${mq.above('sm')} {
    padding: 60px;
  }
  background-color:#EFEFEF;
  padding: 60px 30px;
  margin-left:auto;
  margin-right:auto;
  flex:1 1 100%


`

const CardsWrapper = styled.div`
  width:100%;
  @media (min-width: 2000px) {
    max-width:1366px;
    margin: 0 auto;
  }
`

const CardCol = styled(Col)`
  ${mq.above('lg')} {
    flex:1 1 50%;
    max-width:50%;
    margin-bottom:0;
  }

  margin-bottom:60px;
  flex:1 1 100%;
  max-width:100%;

  &:first-of-type {
    .card {
      box-shadow: rgb(255 201 74) 20px 20px 0px;
    }
  }
  &:last-of-type {
    .card {
      box-shadow: rgb(245 84 162) 20px 20px 0px;
    }
  }

  > a {
    display:block;
    box-sizing: border-box;
  }
`

const LocalCard = styled(Card)`
  margin-right: 20px;
  img {
    height:auto;
  }
`

const LocalCardTitle = styled(CardTitle)`
  font-size:34px;
  line-height:1.2;
  font-weight:800;

  ${mq.below('sm')} {
    font-size:24px;
  }
`

const enhance = compose(
  withState('posts', 'setPosts', []),
  lifecycle({
    componentWillUnmount() {
      this.mounted = false
    },

    async componentDidMount() {
      this.mounted = true


      const fetchURL = this.props.globalData.language.code == 'au' ? `${this.props.globalData.baseUrl}/wp-json/inno/v1/au-blog` : `${this.props.globalData.baseUrl}/wp-json/wp/v2/blog?status=publish&per_page=100`;

      const result = await fetch(fetchURL)

      let posts = await result.json()

      posts.map((post) => {
        let date = new Date()
        date.setTime(post.publish_date)
        post.niceDate = date.toLocaleDateString(
          this.props.post.language.hreflang,
          {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          }
        )
      })

      if (this.mounted) {
        this.props.setPosts(posts)
      }
    },
  })
)

const LatestNews = (props) => {
  const posts = props.posts.splice(0, 2)

  const titleElement =
    props.data.titleElement && props.data.titleElement !== 'default'
      ? props.data.titleElement
      : 'h3'

  return (
    <Container>
      <Content>
        <Row>
          <Col>
            <Title as={titleElement}>{props.data.title}</Title>
          </Col>
        </Row>
      </Content>
      <CardsContainer>
        <CardsWrapper>
          <Row>
            {posts.map((post, index) => (
              <CardCol key={index}>
                 <a href={post.link} target="_blank"> 
                  <LocalCard key={index} className="card">
                    <CardImgWrapper>
                      <img src={post.acf.blog_featured_image.url} />
                    </CardImgWrapper>
                    <CardContent>
                      <LocalCardTitle dangerouslySetInnerHTML={{
                        __html: post.title.rendered
                      }}>
                      </LocalCardTitle>
                    </CardContent>
                  </LocalCard>
                </a>
              </CardCol>
            ))}
          </Row>
        </CardsWrapper>
      </CardsContainer>
    </Container>
  )
}

export default enhance(LatestNews)
